import { render, staticRenderFns } from "./AlternatePhone.vue?vue&type=template&id=56d6d2a0&scoped=true"
import script from "./AlternatePhone.vue?vue&type=script&lang=js"
export * from "./AlternatePhone.vue?vue&type=script&lang=js"
import style0 from "./AlternatePhone.vue?vue&type=style&index=0&id=56d6d2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6d2a0",
  null
  
)

export default component.exports